module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron bg-transparent text-center margin-none"
  }, [_c('h1', [_vm._v("运行状态")]), _vm._v(" "), _c('div', {
    staticClass: "item col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('p', {
    staticClass: "text-title  text-success margin-none"
  }, [_vm._v(_vm._s(_vm.devices.length))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('p', {
    staticClass: "text-title  text-success margin-none"
  }, [_vm._v(_vm._s(_vm.runNum))])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('p', {
    staticClass: "text-title  text-success margin-none"
  }, [_vm._v(_vm._s(_vm.devices.length - _vm.runNum))])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "data-toggle": "isotope"
    }
  }, [_c('div', {
    staticClass: "item col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('table', {
    staticClass: "table table-striped margin-none"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.devices), function(d, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_c('strong', {
      staticClass: "text-muted "
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('a', {
      staticClass: "text-primary"
    }, [_c('strong', [_vm._v(_vm._s(d.Name))])])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "text-primary"
    }, [_c('strong', [_vm._v(_vm._s(d.ChannelID))])])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "text-primary"
    }, [_c('strong', [_vm._v(_vm._s(d.ID))])])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "text-primary"
    }, [_c('strong', [_vm._v(_vm._s(d.Tnumber))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-primary margin-none"
    }, [(d.Status) ? _c('div', {
      staticClass: "label label-success"
    }, [_vm._v("运行中")]) : _vm._e(), _vm._v(" "), (!d.Status) ? _c('div', {
      staticClass: "label label-danger"
    }, [_vm._v("已停止")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-xs",
      attrs: {
        "to": {
          name: 'point',
          params: {
            dname: d.Name,
            dchannel: d.Channel,
            did: d.ID
          }
        }
      }
    }, [_vm._v("查看")])], 1)])
  }))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('p', {
    staticClass: "text-body-2  text-primary margin-none"
  }, [_vm._v("设备总数 ：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('p', {
    staticClass: "text-body-2  text-success margin-none"
  }, [_vm._v("运行数：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('p', {
    staticClass: "text-body-2  text-danger margin-none"
  }, [_vm._v("停止数：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("设备名称")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("链路号")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("设备号")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("终端号")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("运行状态")])]), _vm._v(" "), _c('td', {
    staticClass: "text-right width-200"
  }, [_c('strong', [_vm._v("查看")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f7e120c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Home.vue
// module id = 80
// module chunks = 0